/**
 * Store registry — breaks circular dependencies.
 *
 * Several utility files (getter.ts, helper.ts, …) need access to the Redux
 * store at runtime but cannot import it at the top level without creating
 * circular module dependencies.  This tiny module acts as an indirection
 * layer: store.ts calls `setStore()` right after creating the store, and
 * consumer modules call `getStore()` when they need the store instance.
 */

import type { AppStore } from './store';

let _store: AppStore | null = null;

export function setStore(store: AppStore): void {
  _store = store;
}

export function getStore(): AppStore {
  if (!_store) {
    throw new Error(
      'Redux store has not been initialised yet. ' +
        'Make sure setStore() is called in store.ts.',
    );
  }
  return _store;
}
